import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { BrandOpeningNews } from "./BrandOpeningNews";
import { imgProps } from "../lib/img";

const NEXT = { bakery: "halwai", halwai: "bakery" };
const LABEL = { bakery: "Urban Bakery", halwai: "Urban Halwai" };

export default function ComingSoonStore({ business, kicker }) {
  return (
    <main className="bg-[#FDFBF7] min-h-screen" data-testid="coming-soon-store">
      <section className="relative h-[52vh] min-h-[360px] overflow-hidden">
        <img {...imgProps(business.image, [800, 1200, 1600], "100vw")} alt={business.name} width="1600" height="384" loading="eager" fetchPriority="high" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-[#0F0F0F]/50 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 max-w-7xl mx-auto px-4 sm:px-6 pb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.2em] uppercase text-[#F0B429]" data-testid="coming-soon-kicker">
            <Clock size={13} aria-hidden="true" /> Coming soon
          </span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white mt-2" data-testid="coming-soon-brand">
            {business.name}
          </h1>
          <p className="text-white/80 text-base md:text-lg mt-3 max-w-2xl" data-testid="coming-soon-blurb">
            {business.coming_soon_blurb || business.tagline}
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-3 gap-8 items-start">
        <div className="md:col-span-2">
          <p className="text-xs font-bold tracking-[0.25em] text-[#E04F33] uppercase">{kicker}</p>
          <p className="text-neutral-700 text-base mt-3 max-w-xl">
            Online ordering for {business.name} opens shortly after launch. Nothing here can be added to a cart yet —
            when it goes live, this page becomes the full menu.
          </p>
          <div className="flex flex-wrap gap-3 mt-7">
            <Link to="/store/restaurant" data-testid="coming-soon-order-turban"
              className="inline-flex items-center gap-2 bg-[#E04F33] hover:bg-[#c9432a] text-white font-bold text-sm px-6 py-3 rounded-full transition-colors">
              Order from Urban Turban <ArrowRight size={16} aria-hidden="true" />
            </Link>
            <Link to="/store/express" data-testid="coming-soon-order-express"
              className="inline-flex items-center gap-2 border-2 border-neutral-200 hover:border-black font-bold text-sm px-6 py-3 rounded-full transition-colors">
              Urban Express
            </Link>
            {NEXT[business.slug] && (
              <Link to={`/store/${NEXT[business.slug]}`} className="inline-flex items-center text-sm font-semibold text-neutral-500 hover:text-black px-2 py-3">
                See {LABEL[NEXT[business.slug]]} →
              </Link>
            )}
          </div>
          <BrandOpeningNews business={business} />
        </div>
        <div className="rounded-3xl bg-[#0F0F0F] text-white p-6">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/50">Where</p>
          <p className="font-bold mt-1">2660 N. Halsted St, Lincoln Park</p>
          <p className="text-sm text-white/70 mt-3">
            Same kitchen, same family — Urban Turban and Urban Express are open for pickup and dine-in right now.
          </p>
        </div>
      </section>
    </main>
  );
}
